<template>
  <section class="relative">
    <div class="absolute inset-0">
      <nuxt-img class="hidden object-cover object-top w-full h-full lg:block" width="1920" height="1080" loading="lazy" format="webp"
        sizes="xs:500px sm:760px md:768px lg:1024px xl:1024px 2xl:1024px" :src="bgImage"
        alt="background hero" />

        <nuxt-img class="object-cover object-top w-full h-full lg:hidden" width="1920" height="1080" loading="lazy" format="webp"
        sizes="xs:500px sm:760px md:768px lg:1024px xl:1024px 2xl:1024px"  :src="bgImageMobile"
        alt="background hero" />
    </div>
    <div class="relative z-10 max-w-screen-xl px-4 py-8 mx-auto lg:space-y-20 sm:py-8 2xl:px-0">
    <!-- Row -->
      <div class="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
        <div class="text-gray-400 sm:text-lg">
          <h2 class="mb-4 font-extrabold text-center text-white h2 md:text-left" v-html="mainHeading"></h2>
          <div class="mb-4 font-normal text-center text-white textp md:text-left" v-html="paragraph"></div>
          <!-- List -->
          <ul role="list" class="grid items-start grid-cols-1 mt-3 sm:grid-cols-2 sm:items-start gap-y-6 sm:mt-7 gap-x-3 sm:gap-x-4">
            <li v-for="(item, index) in items" :key="index" class="flex items-start space-x-3 sm:items-start sm-max:w-60 sm-max:mx-auto">
              <nuxt-img class="w-8 h-full mt-1" sizes="xs:40px sm:40px md:40px lg:40px xl:40px 2xl:40px" width="32" height="33" loading="lazy" format="webp"
                src="/assets/images/icon-sun.png" alt="sun" />
              <div>
                <div class="font-bold text-white h4"
                  v-html="item.title"></div>
                <div class="italic font-normal leading-5 text-white textp"
                  v-html="item.text"></div>
              </div>
            </li>
          </ul>
        </div>
        <!-- <nuxt-img loading="lazy"
        format="webp" width="584"
        height="508" sizes="xs:288px sm:420px md:736px lg:1024px xl:560px 2xl:584px" class="flex w-full mb-4 rounded-lg lg:mb-0" :src="imageSrc" :alt="imageAlt"/> -->
      </div>
      <nuxt-img class="relative z-10 max-h-[500px] object-cover object-top lg:hidden mt-6"  width="1920" height="1080" loading="lazy" format="webp"
        sizes="xs:340px sm:440px md:768px lg:1024px xl:1024px 2xl:1024px" :src="mobileBottom"
        alt="woman" />
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  bgImage: {
    type: String,
    default: '/assets/images/woman-coffee-2.png'
  },
  bgImageMobile: {
    type: String,
    default: '/assets/images/bgmobile.png'
  },
  mobileBottom: {
    type: String,
    default: '/assets/images/woman-coffee-mobile.png'
  },
  mainHeading: {
    type: String,
    default: 'Supercharge Your Day With A Burst of Essential Nutrients'
  },
  
  paragraph: {
    type: String,
    default: 'Give your body the building blocks it needs to feel good, be productive, and age gracefully.'
  },
  items: {
    type: Array,
    default: () => [
      {
        title: 'ORGANIC LION’S MANE',
        text: 'Brain support*'
      },
      {
        title: 'COLLAGEN-',
        text: 'Hair, Skin, Nail, Joint, Gut support'
      },
      {
        title: 'ORGANIC CHAGA',
        text: 'Immune Support*'
      },
      {
        title: 'ELECTROLYTES',
        text: 'Helps Rehydrate, mineral replenishment, enhance flavor of coffee.'
      },
      {
        title: 'L-ERGOTHIONENE',
        text: 'Promotes healthy inflammatory response, healthy immune system, and supports cell detoxication'
      },
      {
        title: 'OUR ORGANIC MUSHROOM COFFEE',
        text: 'Low acid, stomach friendly, toxin tested coffee'
      },
      {
        title: 'VITAMIN D',
        text: 'Bone, brain & skin health'
      },
      {
        title: 'RHODIOLA',
        text: 'Adaptogen for stress & anxiety relief'
      },
      {
        title: 'C8 MCT OIL',
        text: 'Support energy, metabolism, cognitive function*'
      },
    ]
  },
  imageSrc: {
    type: String,
    default: 'assets/images/image-woman-coffee.jpg'
  },
  imageSrcMobile: {
    type: String,
    default: 'assets/images/image-woman-coffee.jpg'
  },
  imageAlt: {
    type: String,
    default: 'office feature image'
  }
})

defineBuilderComponent({
  friendlyName: "Description Image List",
  inputs: [
    {
      name: "bgImage",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
      defaultValue: "/assets/images/woman-coffee-2.png"
    },
    {
      name: "bgImageMobile",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
      defaultValue: "/assets/images/bgmobile.png"
    },
    {
      name: "mobileBottom",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
      defaultValue: "/assets/images/woman-coffee-mobile.png"
    },
    {
      name: "mainHeading",
      type: "richText",
      defaultValue: "DISCOVER THE LIFEBOOST DIFFERENCE"
    },
    {
      name: "paragraph",
      type: "richText",
      defaultValue: "We test for over 450 toxins including the nasty ones like mycotoxins & glyphosate, so that your morning can start with these nutrient-dense ingredients instead:"
    },
    {
      name: "items",
      type: "list",
      subFields: [
        {
          name: "title",
          type: "text",
          defaultValue: ""
        },
        {
          name: "text",
          type: "text",
          defaultValue: ""
        }
      ],
      defaultValue: [
      {
        title: 'ORGANIC LION’S MANE',
        text: 'Brain support*'
      },
      {
        title: 'COLLAGEN-',
        text: 'Hair, Skin, Nail, Joint, Gut support'
      },
      {
        title: 'ORGANIC CHAGA',
        text: 'Immune Support*'
      },
      {
        title: 'ELECTROLYTES',
        text: 'Helps Rehydrate, mineral replenishment, enhance flavor of coffee.'
      },
      {
        title: 'L-ERGOTHIONENE',
        text: 'Promotes healthy inflammatory response, healthy immune system, and supports cell detoxication'
      },
      {
        title: 'OUR ORGANIC MUSHROOM COFFEE',
        text: 'Low acid, stomach friendly, toxin tested coffee'
      },
      {
        title: 'VITAMIN D',
        text: 'Bone, brain & skin health'
      },
      {
        title: 'RHODIOLA',
        text: 'Adaptogen for stress & anxiety relief'
      },
      {
        title: 'C8 MCT OIL',
        text: 'Support energy, metabolism, cognitive function*'
      },
    ]
    },
    {
      name: "imageSrc",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
      defaultValue: "assets/images/image-woman-coffee.jpg"
    },
    {
      name: "imageSrcMobile",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
      defaultValue: "assets/images/image-woman-coffee.jpg"
    },
    {
      name: "imageAlt",
      type: "text",
      defaultValue: "office feature image"
    }
  ]
});


</script>